import { ResetActorsRoundStateParams } from '@/app/api/geopolitical-actions/actors/reset/types';
import { ROUTE, axiosInstance } from '@/core/api/axiosInstance';
import {
  ActionActorItem,
  ActionIncidentCountry,
  ActionIncidentItem,
  ActionRoundActorItem,
  ActionRoundItem,
  CreateRoundIncidentParams,
  DeleteRoundIncidentParams,
  UpdateRoundIncidentsParams,
} from '@/server/services/GoogleBigQuery/BigQueryActionsMenuClient.types';

export const geopoliticalActions = {
  getRounds: async () => {
    const { data } = await axiosInstance.get<ActionRoundItem[]>(ROUTE.GEOPOLITICAL_ACTIONS.ROUNDS);
    return data;
  },

  getActors: async () => {
    const { data } = await axiosInstance.get<ActionActorItem[]>(ROUTE.GEOPOLITICAL_ACTIONS.ACTORS);
    return data;
  },

  getIncidentCountries: async () => {
    const { data } = await axiosInstance.get<ActionIncidentCountry[]>(ROUTE.GEOPOLITICAL_ACTIONS.INCIDENT_COUNTRIES);
    return data;
  },

  getIncidents: async ({ roundId, country }: { roundId?: number | null; country?: string | null }) => {
    const { data } = await axiosInstance.get<ActionIncidentItem[]>(ROUTE.GEOPOLITICAL_ACTIONS.INCIDENTS, {
      params: { roundId, country },
    });
    return data;
  },

  updateActionIncidents: async ({ incidents }: UpdateRoundIncidentsParams) => {
    const { data } = await axiosInstance.put<ActionIncidentItem[]>(ROUTE.GEOPOLITICAL_ACTIONS.INCIDENTS, {
      incidents,
    });
    return data;
  },

  createActionIncident: async ({ incident }: CreateRoundIncidentParams) => {
    const { data } = await axiosInstance.post<{ success: boolean; IncidentID: string }>(
      ROUTE.GEOPOLITICAL_ACTIONS.INCIDENTS,
      { incident },
    );
    return data;
  },

  deleteActionIncident: async ({ IncidentID }: DeleteRoundIncidentParams) => {
    const { data } = await axiosInstance.delete<{ success: boolean; IncidentID: string }>(
      ROUTE.GEOPOLITICAL_ACTIONS.INCIDENTS,
      { params: { IncidentID } },
    );
    return data;
  },

  getActorRoundState: async ({ ActorName }: Pick<ActionRoundActorItem, 'ActorName'>) => {
    const { data } = await axiosInstance.get<ActionRoundActorItem[]>(ROUTE.GEOPOLITICAL_ACTIONS.ACTORS_ROUND, {
      params: { ActorName },
    });
    return data;
  },

  updateActorsRoundState: async (items: ActionRoundActorItem[]) => {
    const { data } = await axiosInstance.post<{ success: boolean }>(ROUTE.GEOPOLITICAL_ACTIONS.ACTORS_ROUND, {
      items,
    });
    return data;
  },

  resetActorsRoundState: async (
    ActorName: ResetActorsRoundStateParams['ActorName'],
    roundsToReset?: ResetActorsRoundStateParams['roundsToReset'],
  ) => {
    const { data } = await axiosInstance.get<{ success: boolean }>(ROUTE.GEOPOLITICAL_ACTIONS.ACTORS_RESET, {
      params: { ActorName, roundsToReset } satisfies ResetActorsRoundStateParams,
    });
    return data;
  },
};
